// @ts-nocheck
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import config from 'config';

import useInterval from 'hooks/interval';

import Video from 'models/propTypes/video';

import styles from './PreGameOverlay.module.scss';

const messages = {
  bannerTitle: {
    id: 'preGame.banner.title',
    description: 'Banner title',
  },
  timerTitle: {
    id: 'preGame.timer.title',
    description: 'Timer title',
  },
  message1: {
    id: 'preGame.message1',
    description: 'Event message 1',
  },
  message2: {
    id: 'preGame.message2',
    description: 'Event message 2',
  },
};

const getCountdownDisplayTime = seconds => {
  const timeStr = new Date(seconds * 1000).toISOString();
  if (seconds > 3600) return timeStr.substr(11, 8);
  return timeStr.substr(14, 5);
};

const PreGameOverlay = ({ video, bannerMode }) => {
  const intl = useIntl();
  const [countdownSeconds, setCountdownSeconds] = useState(0);

  const pregameTitle = video?.event?.pregame?.about?.title;
  const networkName = pregameTitle || config.brand.defaultNetworkName;

  useInterval(() => {
    const now = Math.floor(new Date().getTime() / 1000);
    const videoStartDate = video?.schedule.videoStartDate || now;
    const countDown = Math.max(videoStartDate - now, 0);
    if (!countdownSeconds && !countDown) return;
    setCountdownSeconds(countDown);
  }, 1000);

  if (!video || !countdownSeconds) return null;

  const timerTitle = intl.formatMessage(messages.timerTitle);
  const bannerTitle = video.about.title
    ? intl.formatMessage(messages.bannerTitle, {
        event: video.about.title,
      })
    : timerTitle;
  const countdownTime = getCountdownDisplayTime(countdownSeconds);
  const message1 = intl.formatMessage(messages.message1, {
    eventType: config.brand.eventType,
  });
  const message2 = intl.formatMessage(messages.message2, {
    networkName,
    preGameDescription: config.brand.preGameDescription,
  });

  return (
    <div
      className={classNames({
        [styles.background]: bannerMode,
      })}
      data-testid="pre-game-overlay"
    >
      <div
        className={classNames(styles.expanded, styles.overlay, {
          [styles.shrinked]: !bannerMode,
        })}
      />
      <div
        className={classNames(styles.expanded, styles.banner, {
          [styles.shrinked]: !bannerMode,
        })}
      >
        <div className={styles.bannerTitle}>{bannerTitle}</div>
        <div className={styles.bannerCountdownTime}>{countdownTime}</div>
        <div className={styles.bannerMessage}>{message1}</div>
        <div className={styles.bannerMessage}>{message2}</div>
      </div>
      <div
        className={classNames(styles.expanded, styles.timer, {
          [styles.timerShrinked]: !bannerMode,
        })}
      >
        <div className={styles.timerTitle}>{timerTitle}</div>
        <div className={styles.timerCountdownTime}>{countdownTime}</div>
      </div>
    </div>
  );
};

PreGameOverlay.propTypes = {
  video: Video,
  bannerMode: PropTypes.bool,
};

PreGameOverlay.defaultProps = {
  video: null,
  bannerMode: true,
};

export default PreGameOverlay;
